var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAppBlackOnBondiMint = function SvgAppBlackOnBondiMint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 114 114",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h114v114H0z",
    fill: "#b2fce4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m88.718 38.468-21.63-12.134c-6.348-3.562-14.285.889-14.285 8.018v1.245c0 1.124.619 2.165 1.62 2.725l4.084 2.291c1.2.675 2.695-.167 2.695-1.512v-3.096c0-1.548 1.722-2.516 3.1-1.742l18.734 10.513a1.98 1.98 0 0 1 0 3.479L64.301 58.768c-1.377.774-3.099-.194-3.099-1.742V55.38c0-7.13-7.936-11.586-14.29-8.019l-21.63 12.135a9.132 9.132 0 0 0 0 16.037l21.63 12.134c6.348 3.562 14.29-.889 14.29-8.018v-1.245c0-1.124-.619-2.16-1.62-2.725L55.5 73.382c-1.2-.675-2.696.167-2.696 1.511v3.097c0 1.548-1.722 2.516-3.099 1.742L30.969 69.219a1.985 1.985 0 0 1 0-3.484l18.735-10.513c1.377-.774 3.1.193 3.1 1.741v1.648c0 7.13 7.936 11.586 14.285 8.018l21.63-12.134c6.348-3.552 6.348-12.465 0-16.027z",
    fill: "#000"
  })));
};

export default SvgAppBlackOnBondiMint;